module.exports = __webpack_public_path__ + "static/media/ChaSiuCheon.4b646cb1.jpg";